import { Pusher } from "./Pusher.js";
export async function loadExternalPushInteraction(engine, refresh = true) {
    await engine.addInteractor("externalPush", (container) => new Pusher(container), refresh);
}
export * from "./Options/Classes/Push.js";
export * from "./Options/Interfaces/IPush.js";
